import React from 'react'
import { connect } from 'react-redux'
import DraggableWrapper from '../../../../Utils/DraggableWrapper'
import SelectedBorder from '../../../../Utils/SelectedBorder'
import { ImgContainer } from './style'
import dragResize from '../../../../../image/dragresize.svg'
import { convertStyle, getDiffToMobileConvert, convertMobileUmitableFields } from '../../../../../api/converter'
import { Resizable } from 're-resizable'
import { slideActions, menuActions } from '../../../../../actions'
import { keyDownMoveHandler, keyUpMoveHandler } from '../../../../Utils/functions'
import { getRightPropertyValue, remapValue } from '../../../../../../Utils/helpers'
import { bottomLeftResizeHandleStyle, bottomLineResizeHandleStyle, bottomResizeHandleStyle, bottomRightResizeHandleStyle, leftLineResizeHandleStyle, leftResizeHandleStyle, rightLineResizeHandleStyle, rightResizeHandleStyle, topLeftResizeHandleStyle, topLineResizeHandleStyle, topResizeHandleStyle, topRightResizeHandleStyle } from '../style'
import { getBackgroundGradient, getUrlVar } from '../../../../../../Utils/utils'
import { Language } from '../../../../../../Utils/Translation'
import { Icon } from '../../../../Utils/Icon'
import { COLORS } from '../../../../../../Utils/colors'

/**
 * Calculates the dimensions of an image to fit within a container while maintaining the original aspect ratio.
 * 
 * @param {Object} containerDimensions - The dimensions of the container.
 * @param {number} containerDimensions.width - The width of the container.
 * @param {number} containerDimensions.height - The height of the container.
 * @param {Object} originalDimensions - The original dimensions of the image.
 * @param {number} originalDimensions.width - The original width of the image.
 * @param {number} originalDimensions.height - The original height of the image.
 * @returns {Object} The dimensions of the image to fit within the container.
 * @returns {number} returnDims.width - The calculated width of the image.
 * @returns {number} returnDims.height - The calculated height of the image.
 */
export const getImageDimensions = (containerDimensions = { width: 0, height: 0 }, originalDimensions = { width: 0, height: 0 }) => {
    const ratio = originalDimensions.width / originalDimensions.height

    const returnDims = { width: 0, height: 0 }
    if (containerDimensions.width > containerDimensions.height) {
        returnDims.width = containerDimensions.width
        returnDims.height = containerDimensions.width * (1 / ratio)
    } else {
        returnDims.width = containerDimensions.height * ratio
        returnDims.height = containerDimensions.height
    }

    return returnDims
}

/**
 * Calculates the absolute position of an image from its center point.
 * 
 * @param {Object} centerPoint - The center point of the image.
 * @param {number} centerPoint.x - The x-coordinate of the center point.
 * @param {number} centerPoint.y - The y-coordinate of the center point.
 * @param {Object} imageFrameSize - The size of the image frame.
 * @param {number} imageFrameSize.width - The width of the image frame.
 * @param {number} imageFrameSize.height - The height of the image frame.
 * @param {Object} imageSize - The size of the image.
 * @param {number} imageSize.width - The width of the image.
 * @param {number} imageSize.height - The height of the image.
 * @param {number} imageScale - The scale of the image (default is 100).
 * @returns {Object} The absolute position of the image.
 * @returns {number} transformX - The x-coordinate of the absolute position.
 * @returns {number} transformY - The y-coordinate of the absolute position.
 */
export const calculateAbsoluteFromCenterPoint = (
    centerPoint = { x: .5, y: .5 },
    imageFrameSize = { width: 0, height: 0 },
    imageSize = { width: 0, height: 0 },
    imageScale = 100
) => {
    const transformX = -(centerPoint.x * imageSize.width * (imageScale / 100)) + imageFrameSize.width / 2
    const transformY = -(centerPoint.y * imageSize.height * (imageScale / 100)) + imageFrameSize.height / 2
    return {
        transformX: transformX,
        transformY: transformY
    }

}
/**
 * Calculates the center point of an image from its absolute position.
 * 
 * @param {Object} imageCropAbsolute - The absolute position of the image crop.
 * @param {number} imageCropAbsolute.transformX - The x-coordinate of the absolute position.
 * @param {number} imageCropAbsolute.transformY - The y-coordinate of the absolute position.
 * @param {Object} imageFrameSize - The size of the image frame.
 * @param {number} imageFrameSize.width - The width of the image frame.
 * @param {number} imageFrameSize.height - The height of the image frame.
 * @param {Object} imageSize - The size of the image.
 * @param {number} imageSize.width - The width of the image.
 * @param {number} imageSize.height - The height of the image.
 * @param {number} imageScale - The scale of the image (default is 100).
 * @returns {Object} The center point of the image.
 * @returns {number} centerPoint.x - The x-coordinate of the center point.
 * @returns {number} centerPoint.y - The y-coordinate of the center point.
 */
export const calculateCenterPointFromAbsolute = (
    imageCropAbsolute = { transformX: 0, transformY: 0 },
    imageFrameSize = { width: 0, height: 0 },
    imageSize = { width: 0, height: 0 },
    imageScale = 100
) => {
    // console.log('calculateCenterPointFromAbsolute', imageCropAbsolute, imageFrameSize, imageSize, imageScale)
    const centerPoint = {
        x: (Math.abs(imageCropAbsolute.transformX) + imageFrameSize.width / 2) / (imageSize.width * (imageScale / 100)),
        y: (Math.abs(imageCropAbsolute.transformY) + imageFrameSize.height / 2) / (imageSize.height * (imageScale / 100))
    }

    return centerPoint
}

const CurrentLanguage = Language(getUrlVar('language'))

class ImageCaption extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            shapeStyle: {
                backgroundColor: null,
                height: null,
                position: null,
                width: null,
            }
        }

        this.keyDownHandler = (event) => keyDownMoveHandler({
            event,
            isMoveElement: this.props.captionSelectedArray.length === 1 && this.props.caption.index === this.props.editingCaptionIndex && !this.props.previewSlide,
            index: this.props.caption.index, // удалит потом
            editingCaptionIndex: this.props.editingCaptionIndex, // удалит потом
            transformPosition: this.state.shapeStyle.position,
            stateTempPosition: this.state.tempPosition,
            editingText: this.props.editingText,
            callback: this.changeTempPositionInState.bind(this),
        });

        this.keyUpHandler = (event) => keyUpMoveHandler({
            event,
            isMoveElement: this.props.captionSelectedArray.length === 1 && this.props.caption.index === this.props.editingCaptionIndex && !this.props.previewSlide,
            stateTempPosition: this.state.tempPosition,
            editingText: this.props.editingText,
            callback: this.changeElementPosition.bind(this),
        })
    }


    componentWillMount() {
        this.setState({
            shapeStyle: this.getShapeStyle(this.props.caption, this.props.viewType)
        })
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            shapeStyle: this.getShapeStyle(newProps.caption, newProps.viewType)
        })
    }

    componentDidMount() {
        window.addEventListener('keydown', this.keyDownHandler)
        window.addEventListener('keyup', this.keyUpHandler)
    }
    componentWillUnmount() {
        window.removeEventListener('keydown', this.keyDownHandler)
        window.removeEventListener('keyup', this.keyUpHandler)
    }

    // обрабатываем нажатия клавиши для передвижения
    // keyDownHandler(event) {
    //     console.log('keydown ',this.props.caption.index);
    //     if (this.props.editingCaptionIndex !== this.props.caption.index) return
    //     // проверяю что не инпут, чтобы если текст выделен и в это время в слайдере меняется значение с помощью кнопок
    //     // чтобы текст не менял позицию 
    //     if (event.target.tagName.toLowerCase() === 'input') {
    //         return
    //     }

    //     if (event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40) {
    //         let position = this.state.shapeStyle.position
    //         let tempPosition
    //         if (this.state.tempPosition) {
    //             tempPosition = this.state.tempPosition
    //         } else {
    //             tempPosition = { x: 0, y: 0 }
    //             // this.setState({tempPosition: tempPosition})
    //         }

    //         const delta = event.shiftKey ? 10 : 1
    //         console.log('delta',delta);
    //         switch (event.keyCode) {
    //             case 37:
    //                 position.x -= delta
    //                 tempPosition.x -= delta
    //                 break;
    //             case 38:
    //                 position.y -= delta
    //                 tempPosition.y -= delta
    //                 break;

    //             case 39:
    //                 position.x += delta
    //                 tempPosition.x += delta
    //                 break;

    //             case 40:
    //                 position.y += delta
    //                 tempPosition.y += delta
    //                 break;
    //         }
    //         this.setState({shapeStyle: {...this.state.shapeStyle, position}, tempPosition})
    //     }
    // }

    // keyUpHandler(event) {
    //     console.log('keyup ',this.props.caption.index);
    //     if (this.props.editingCaptionIndex !== this.props.caption.index) return
    //     if (this.state.tempPosition && (event.keyCode == 37 || event.keyCode == 38 || event.keyCode == 39 || event.keyCode == 40)) {
    //         const tempPosition = this.state.tempPosition
    //         this.props.dispatch(slideActions.changeAllSelectedCaptionsPosition(tempPosition.x, tempPosition.y))
    //         this.setState({tempPosition: null})
    //     } 
    // }

    changeTempPositionInState(position, tempPosition) {
        this.setState({ shapeStyle: { ...this.state.shapeStyle, position }, tempPosition })
    }

    changeElementPosition() {
        const tempPosition = this.state.tempPosition
        this.props.dispatch(slideActions.changeAllSelectedCaptionsPosition(tempPosition.x, tempPosition.y))
        this.setState({ tempPosition: null })
    }

    getShapeStyle(caption, viewType) {
        let convertedStyle = convertStyle(caption,
            this.props.widgetData.originalWidth,
            this.props.widgetData.originalHeight, false)
        const isMobile = viewType === 'mobile'
        const desktopDims = { width: this.props.widgetData.width, height: this.props.widgetData.height }
        const mobileDims = { width: this.props.widgetData.mobileWidth, height: this.props.widgetData.mobileHeight }
        if (viewType === 'mobile') {
            const { mobileDiffW, mobileDiffH } = getDiffToMobileConvert(
                this.props.widgetData.originalWidth,
                this.props.widgetData.originalHeight,
                this.props.widgetData.mobileWidth,
                this.props.widgetData.mobileHeight,
            )
            const maxDiff = mobileDiffW > mobileDiffH ? mobileDiffW : mobileDiffH
            convertedStyle = convertMobileUmitableFields(convertedStyle, mobileDiffW, mobileDiffH, maxDiff)
        }
        let borderRadiusProperty, borderWidthProperty, widthProperty, positionProperty, heightProperty, paddingProperty;

        switch (viewType) {
            case 'desktop':
                borderRadiusProperty = 'borderRadius';
                borderWidthProperty = 'borderWidth';
                widthProperty = 'width';
                heightProperty = 'height';
                positionProperty = 'position';
                paddingProperty = 'padding';
                break;

            case 'mobile':
                borderRadiusProperty = 'mobileBorderRadius';
                borderWidthProperty = 'mobileBorderWidth';
                widthProperty = 'mobileWidth';
                heightProperty = 'mobileHeight';
                positionProperty = 'mobilePosition';
                paddingProperty = 'mobilePadding';
                break;
        }
        const xProp = caption.boxId === '' ? 'x' : 'relativeX'
        const yProp = caption.boxId === '' ? 'y' : 'relativeY'

        let captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, convertedStyle)
        if (caption.boxId !== '' && isMobile && caption.mobilePosition && caption.mobilePosition.relativeX == undefined) {
            const clonedCaption = _.cloneDeep(convertedStyle)
            delete clonedCaption.mobilePosition
            const convertedPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, clonedCaption)
            captionPosition = {
                ...captionPosition,
                relativeX: convertedPosition.relativeX,
                relativeY: convertedPosition.relativeY
            }
        }
        const maxWidth = this.props.widgetData[widthProperty] - captionPosition[xProp]
        const maxHeight = this.props.widgetData[heightProperty] - captionPosition[yProp]
        // const captionStyle = {
        //     backgroundColor: getBackgroundGradient({ backgroundColor: convertedStyle.backgroundColor }),
        //     overlayColor: getBackgroundGradient({ backgroundColor: convertedStyle.overlayColor }),
        //     borderColor: convertedStyle.borderColor,
        //     borderRadius: convertedStyle[borderRadiusProperty],
        //     borderWidth: convertedStyle[borderWidthProperty],
        //     padding: convertedStyle[paddingProperty],
        //     height: convertedStyle[heightProperty],
        //     shadow: !convertedStyle.hasShadow ? '' : `${convertedStyle.shadow.x}px ${convertedStyle.shadow.y}px ${convertedStyle.shadow.blur}px ${convertedStyle.shadow.size}px ${convertedStyle.shadow.color}`,
        //     position: {
        //         x: convertedStyle[positionProperty][xProp],
        //         y: convertedStyle[positionProperty][yProp]
        //     },
        //     width: convertedStyle[widthProperty],
        //     zIndex: convertedStyle.layer,

        //     maxWidth,
        //     maxHeight
        // }


        const captionStyle = {
            backgroundColor: getBackgroundGradient({ backgroundColor: convertedStyle.backgroundColor }),
            overlayColor: getBackgroundGradient({ backgroundColor: convertedStyle.overlayColor }),
            borderColor: convertedStyle.borderColor,
            borderRadius: getRightPropertyValue(desktopDims, mobileDims, 'borderRadius', isMobile, convertedStyle),
            borderWidth: getRightPropertyValue(desktopDims, mobileDims, 'borderWidth', isMobile, convertedStyle),
            padding: getRightPropertyValue(desktopDims, mobileDims, 'padding', isMobile, convertedStyle),
            height: getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, convertedStyle),
            shadow: !convertedStyle.hasShadow ? '' : `${convertedStyle.shadow.x}px ${convertedStyle.shadow.y}px ${convertedStyle.shadow.blur}px ${convertedStyle.shadow.size}px ${convertedStyle.shadow.color}`,
            position: {
                x: captionPosition[xProp],
                y: captionPosition[yProp]
            },
            width: getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, convertedStyle),
            zIndex: convertedStyle.layer,

            maxWidth,
            maxHeight
        }


        // if (captionStyle.position.x > this.props.widgetData[widthProperty]) {
        //     captionStyle.position.x = 0
        // }

        // if (captionStyle.position.y > this.props.widgetData[heightProperty]) {
        //     captionStyle.position.y = 0
        // }

        return captionStyle
    }

    changeDimensions(delta) {
        this.props.dispatch(slideActions.changeCaptionDimesions(this.props.caption.index, delta, this.props.viewType))
    }
    setNewDimensions(mobileViewScale) {
        this.props.dispatch(slideActions.changeCaptionDimesions(this.props.caption.index, {}, this.props.viewType, mobileViewScale))
        // тут addAction, т.к. в саге он будет вызываться для каждой капчи при массовом изменении бордера или паддинга
        this.props.dispatch(slideActions.addAction())
    }

    getCropButton() {
        const mobileViewScale = (this.props.mobileViewScale / 100)
        const index = this.props.index
        return (
            <div
                style={{
                    background: '#fff',
                    padding: '6px',
                    borderRadius: '50%',
                    // boxShadow: `0 0 12px 0 rgba(22,45,61,.26)`,
                    zIndex: 2,
                    cursor: 'pointer',
                    color: COLORS.deepBlue,
                    marginLeft: '10px',
                }}
                onMouseDown={e => {
                    e.stopPropagation()
                    this.props.dispatch(menuActions.imageCaptionCropToggle(index))
                }}
                onClick={e => {
                    e.stopPropagation()
                    this.props.dispatch(menuActions.imageCaptionCropToggle(index))
                }}
            >
                <span style={{}}>
                    <Icon
                        iconStyle={{ display: 'block', }}
                        size={12}
                        type={'active-not-hover'}
                        name={'crop'}

                    />
                </span>
            </div>
        )
    }


    render() {
        const caption = this.props.caption
        const index = this.props.index
        const isMobile = this.props.viewType === 'mobile'
        const resizableShapeStyle = { position: 'absolute', zIndex: this.state.shapeStyle.zIndex, left: 0, top: 0 }
        // console.log(this.state.shapeStyle)
        // учитываем увеличение лупой на мобильном виде
        const mobileViewScale = (this.props.mobileViewScale / 100)
        // уникальное имя для анимации в превью
        const unicClassName = this.props.previewSlide ? `caption-${this.props.slideIndex}-${caption.index}-${this.props.unicClassName} ` : ''


        let svgShadow = ''
        if (caption.hasShadow) {
            const desktopDims = { width: this.props.widgetData.width, height: this.props.widgetData.height }
            const mobileDims = { width: this.props.widgetData.mobileWidth, height: this.props.widgetData.mobileHeight }
            svgShadow = `drop-shadow(${getRightPropertyValue(desktopDims, mobileDims, 'x', isMobile, caption.shadow)}px `
                + `${getRightPropertyValue(desktopDims, mobileDims, 'y', isMobile, caption.shadow)}px `
                + `${getRightPropertyValue(desktopDims, mobileDims, 'blur', isMobile, caption.shadow)}px `
                + `${caption.shadow.color})`
        }

        const enableResizeHandle = (!this.props.previewSlide && this.props.selected)

        const defaultSize = { width: this.state.shapeStyle.width, height: this.state.shapeStyle.height }
        defaultSize.width -= this.state.shapeStyle.padding * 2
        defaultSize.height -= this.state.shapeStyle.padding * 2
        defaultSize.width -= this.state.shapeStyle.borderWidth * 2
        defaultSize.height -= this.state.shapeStyle.borderWidth * 2

        const imgDims = getImageDimensions(defaultSize, caption.originalDimensions)

        const imageCrop = getRightPropertyValue({}, {}, 'crop', isMobile, caption)
        // const imageCrop = caption.crop

        // console.log('imageCrop', imageCrop)

        let imageScale = imageCrop.scale

        if (!imageCrop.editedByCaption) {
            if (imgDims.width * (imageScale / 100) < defaultSize.width) {
                imageScale = (defaultSize.width / imgDims.width) * 100 > imageScale ? (defaultSize.width / imgDims.width) * 100 : imageScale
                this.props.dispatch(slideActions.setImageCaptionCrop(index, { crop: { ...imageCrop, scale: imageScale + 5, editedByCaption: true } }, isMobile))
                return null
            } else if (imgDims.height * (imageScale / 100) < defaultSize.height) {
                imageScale = (defaultSize.height / imgDims.height) * 100 > imageScale ? (defaultSize.height / imgDims.height) * 100 : imageScale
                this.props.dispatch(slideActions.setImageCaptionCrop(index, { crop: { ...imageCrop, scale: imageScale + 5, editedByCaption: true } }, isMobile))
                return null
            }
        }
        

        const imageCropAbsolute = calculateAbsoluteFromCenterPoint(imageCrop.centerPoint, defaultSize, imgDims, imageScale)

        // console.log('imageCropAbsolute', imageCropAbsolute)
        // console.log('center point', imageCrop.centerPoint)
        // console.log('defaultSize', defaultSize)
        // console.log('imgDims', imgDims)

        let boundsUsed = false
        const bounds = imageCrop ? {
            top: -(imgDims.height * (imageScale / 100) - defaultSize.height),
            left: -(imgDims.width * (imageScale / 100) - defaultSize.width),
            right: 0,
            bottom: 0
        } : null

        if (imageCropAbsolute.transformY < bounds.top) {
            imageCropAbsolute.transformY = Math.ceil(bounds.top)
            boundsUsed = true
        }
        if (imageCropAbsolute.transformY > bounds.bottom) {
            imageCropAbsolute.transformY = bounds.bottom
            boundsUsed = true
        }

        if (imageCropAbsolute.transformX < bounds.left) {
            imageCropAbsolute.transformX = Math.ceil(bounds.left)
            boundsUsed = true
        }
        if (imageCropAbsolute.transformX > bounds.right) {
            imageCropAbsolute.transformX = bounds.right
            boundsUsed = true
        }

        if (boundsUsed && !imageCrop.editedByCaption) {
            const centerPoint = calculateCenterPointFromAbsolute(imageCropAbsolute, defaultSize, imgDims, imageScale)
            this.props.dispatch(slideActions.setImageCaptionCrop(index, { crop: { ...imageCrop, centerPoint: centerPoint, editedByCaption: true } }, isMobile))
            return null
        }

        const flipStyle = caption.flip ? `scaleX(${caption.flip.x ? -1 : 1}) scaleY(${caption.flip.y ? -1 : 1})` : ''
        return (
            <DraggableWrapper
                index={this.props.caption.index}
                selected={this.props.selected}
                position={this.state.shapeStyle.position}
                cancel={`.react-resizable-handle`}
                unselectCaption={this.props.unselectCaption}
                inUnvisibleBox={this.props.inUnvisibleBox}
                captionRandomKey={this.props.caption.captionRandomKey}
                onDrag={(event, data) => { this.props.onDrag(event, data) }}
                onDragStop={(event, data) => {
                    if (this.props.onDragStop) {
                        this.props.onDragStop(event, data)
                    }
                }}
                currentGrid={this.props.currentGrid}
                currentAlign={this.props.currentAlign}
            >
                <Resizable
                    id={`service-${caption.id}`}
                    style={resizableShapeStyle}
                    defaultSize={{ width: this.state.shapeStyle.width, height: this.state.shapeStyle.height }}
                    key={`preview-slide-caption-resize-image-${this.props.caption.id}-${this.props.caption.index}`}
                    // handleStyles={this.props.selected ? this.state.handleStyles : {}}
                    enable={{
                        top: enableResizeHandle, right: enableResizeHandle, bottom: enableResizeHandle, left: enableResizeHandle, topRight: enableResizeHandle, bottomRight: enableResizeHandle, bottomLeft: enableResizeHandle, topLeft: enableResizeHandle
                    }}
                    handleStyles={this.props.selected ? {
                        // bottomRight: {
                        //     // backgroundColor: '#fff',
                        //     backgroundImage: `url('${dragResize}')`,
                        //     backgroundPosition: 'center',
                        //     backgroundSize: 'cover',
                        //     backgroundRepeat: 'no-repeat',
                        //     right: 0,
                        //     bottom: 0,
                        //     width: `20px`,
                        //     height: `20px`,
                        // }
                        bottom: bottomLineResizeHandleStyle(this.props.mobileViewScale / 100),
                        bottomLeft: bottomLeftResizeHandleStyle(this.props.mobileViewScale / 100),
                        bottomRight: bottomRightResizeHandleStyle(this.props.mobileViewScale / 100),
                        top: topLineResizeHandleStyle(this.props.mobileViewScale / 100),
                        topLeft: topLeftResizeHandleStyle(this.props.mobileViewScale / 100),
                        topRight: topRightResizeHandleStyle(this.props.mobileViewScale / 100),
                        right: rightLineResizeHandleStyle(this.props.mobileViewScale / 100),
                        left: leftLineResizeHandleStyle(this.props.mobileViewScale / 100),
                        
                    } : {}}
                    handleClasses={
                        {
                            right: 'react-resizable-handle react-resizable-handle-right',
                            left: 'react-resizable-handle react-resizable-handle-left',
                            bottomRight: 'react-resizable-handle',
                            bottom: 'react-resizable-handle react-resizable-handle-bottom',
                            bottomLeft: 'react-resizable-handle',
                            top: 'react-resizable-handle react-resizable-handle-top',
                            topRight: 'react-resizable-handle',
                            topLeft: 'react-resizable-handle',
                        }
                    }
                    minWidth={1}
                    minHeight={1}
                    lockAspectRatio={this.props.shiftIsPress}
                    // maxWidth={this.state.shapeStyle.maxWidth}
                    // maxHeight={this.state.shapeStyle.maxHeight}
                    onResizeStop={(e, data, ref, delta) => {
                        this.setNewDimensions(mobileViewScale)
                        this.props.onResizeStop(e, data, ref, delta)
                    }}
                    onResize={(e, data, ref, delta) => {
                        this.props.onResize(e, data, ref, delta)
                    }}
                    onResizeStart={(e, data, ref, delta) => {
                        e.stopPropagation()
                        this.props.onResizeStart(e, data, ref, delta)
                    }}
                    // onResizeStop={(e, direction, ref, delta) => this.changeDimensions(delta)}
                    snap={this.props.snap}
                    snapGap={this.props.snapGap}
                    scale={mobileViewScale}
                >
                    <SelectedBorder
                        key={`border-${this.props.caption.index}-${this.props.previewSlide}`}
                        index={this.props.caption.index}
                        selected={this.props.selected}
                        captionType={CurrentLanguage.IMAGE}
                        mobileViewScale={mobileViewScale}
                        isPremiumElem={caption.isPremiumElem}
                        cropButton={this.props.selected ? this.getCropButton() : null}
                    >
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                background: this.state.shapeStyle.backgroundColor,
                                padding: this.state.shapeStyle.padding,
                            }}
                            className={`caption-${this.props.slideIndex}-${this.props.caption.index} ${unicClassName} ${this.props.cancelClassname ? this.props.cancelClassname : ''} animated animate-${this.props.slideIndex}-${this.props.caption.index}`}

                        >
                            <ImgContainer
                                // onClick={(e) => this.props.unselectCaption(e, this.props.caption.index, this.props.selected)}
                                id={`caption-${this.props.caption.index}`}
                                data-caption-id={`${this.props.caption.id}`}
                                {...this.state.shapeStyle}
                                onClick={e => {
                                    e.stopPropagation();
                                    // в режиме предпросмотра не выделяем ничего
                                    if (this.props.previewSlide) return
                                    if (this.props.editingText && this.props.index !== this.props.editingCaptionIndex) {
                                        if (this.props.captionSelectedArray.some(i => i === this.props.index)) {
                                            // если кликнутая капча - одна из выделенных
                                            this.props.dispatch(menuActions.switchEditingTextPanel(false))
                                        } else {
                                            this.props.dispatch(menuActions.chooseAnotherOneCaption(this.props.index))
                                        }
                                    }
                                }}
                            >
                                {/* {
                                    this.props.selected &&
                                    <div
                                        style={{
                                            position: 'fixed',
                                            top: `${remapValue(mobileViewScale, 1, 3, -38, -20)}px`,
                                            right: `${remapValue(mobileViewScale, 1, 3, 10, 0)}px`,
                                            background: '#fff',
                                            padding: '8px 9px',
                                            borderRadius: '50%',
                                            boxShadow: `0 0 12px 0 rgba(22,45,61,.26)`,
                                            zIndex: 2,
                                            cursor: 'pointer',
                                            color: COLORS.deepBlue,
                                            scale: isMobile ? .7 : 1,
                                            transform: `translate(${(mobileViewScale) * 2}px, -${(mobileViewScale) * 2}px) scale(${1 / (mobileViewScale)})`
                                        }}
                                        onMouseDown={e => {
                                            e.stopPropagation()
                                            this.props.dispatch(menuActions.imageCaptionCropToggle(index))
                                        }}
                                        onClick={e => {
                                            e.stopPropagation()
                                            this.props.dispatch(menuActions.imageCaptionCropToggle(index))
                                        }}
                                    >
                                        <span style={{}}>
                                            <Icon
                                                iconStyle={{ display: 'block', }}
                                                size={12}
                                                type={'active-not-hover'}
                                                name={'crop'}

                                            />
                                        </span>
                                    </div>
                                } */}
                                <img
                                    src={caption.imageURL}
                                    style={{
                                        display: 'block',
                                        position: 'absolute',
                                        width: imgDims.width * (imageScale / 100),
                                        height: imgDims.height * (imageScale / 100),
                                        maxHeight: 'initial',
                                        maxWidth: 'initial',
                                        transform: `translate(${imageCropAbsolute.transformX}px, ${imageCropAbsolute.transformY}px) ${flipStyle}`
                                    }}
                                />
                                <div className='overlay' />
                            </ImgContainer>
                        </div>




                    </SelectedBorder>

                </Resizable>
            </DraggableWrapper>
        )
    }
}


function mapStateToProps(state) {

    return {
        widgetData: state.slideReducer.widgetData,
        rulersArray: state.menuReducer.rulersArray,
        editingText: state.menuReducer.editingText,
        shiftIsPress: state.menuReducer.shiftIsPress,
        gridOn: state.menuReducer.gridOn,
        captionSelectedArray: state.menuReducer.captionSelectedArray,
        editingCaptionIndex: state.menuReducer.editingCaptionIndex,
        captions: state.slideReducer.captions,
        viewType: state.menuReducer.viewType,
        slideIndex: state.slideReducer.index,
        boxFigureIsEdit: state.menuReducer.boxFigureIsEdit,
        previewSlide: state.menuReducer.previewSlide,
        mobileViewScale: state.menuReducer.mobileViewScale,
        unicClassName: state.menuReducer.unicClassName,
    }
}

export default connect(mapStateToProps)(ImageCaption)